import { useCallback, useEffect, useState } from 'react'
import { loadNoBudgetDepartments } from '@/services/noBudgetDepartmentCache'

export const NO_BUDGET_HINT = '该部门无差旅预算，请重新选择'
export const NO_BUDGET_TAG = '无差旅预算'

export function useNoBudgetDepartments(): {
  noBudgetIds: Set<string>
  loaded: boolean
  isDeptNoBudget: (deptId?: string | null) => boolean
} {
  const [noBudgetIds, setNoBudgetIds] = useState<Set<string>>(new Set())
  const [loaded, setLoaded] = useState(false)

  useEffect(() => {
    let cancelled = false
    loadNoBudgetDepartments().then((set) => {
      if (!cancelled) {
        setNoBudgetIds(set)
        setLoaded(true)
      }
    })
    return () => {
      cancelled = true
    }
  }, [])

  const isDeptNoBudget = useCallback(
    (deptId?: string | null) => !!deptId && noBudgetIds.has(deptId),
    [noBudgetIds]
  )

  return { noBudgetIds, loaded, isDeptNoBudget }
}
